export class ValidateImage {
    name: string;
    purpose: string;
    format: string;

    /**
     * Constructor
     *
     * @param rol
     */
    constructor(img) {
        this.name = img.name || '';
        this.purpose = img.purpose || '';
        this.format = img.format || '';
    }
}